import { TextField } from "@mui/material";
import type { CreateIntegrationRequest } from "../../../../common/interfaces/admin/integration.interface";
import LauncherPreview from "./launcher-preview.comp";

export interface IntegrationBrandingStepProps {
    value: Pick<
        CreateIntegrationRequest,
        "launcherDisplayName" | "launcherPrimaryColor" | "launcherIconUrl" | "welcomeMessage"
    >;
    onChange(patch: Partial<IntegrationBrandingStepProps["value"]>): void;
}

export default function IntegrationBrandingStep({ value, onChange }: IntegrationBrandingStepProps) {
    return (
        <div className="integration-step integration-step--branding">
            <div className="integration-step__form">
                <TextField
                    label="Display name"
                    fullWidth
                    required
                    inputProps={{ maxLength: 60 }}
                    value={value.launcherDisplayName ?? ""}
                    onChange={e => onChange({ launcherDisplayName: e.target.value })}
                    helperText="Shown to end users in the launcher and chat header."
                />

                <div className="integration-color-row">
                    <TextField
                        label="Primary color"
                        value={value.launcherPrimaryColor ?? "#1976d2"}
                        onChange={e => onChange({ launcherPrimaryColor: e.target.value })}
                        inputProps={{ maxLength: 7, style: { fontFamily: "monospace" } }}
                        sx={{ flex: "1 1 auto" }}
                    />
                    <input
                        type="color"
                        aria-label="Pick primary color"
                        value={
                            /^#[0-9a-fA-F]{6}$/.test(value.launcherPrimaryColor ?? "")
                                ? (value.launcherPrimaryColor as string)
                                : "#1976d2"
                        }
                        onChange={e => onChange({ launcherPrimaryColor: e.target.value })}
                    />
                </div>

                <TextField
                    label="Icon URL"
                    fullWidth
                    placeholder="https://…"
                    value={value.launcherIconUrl ?? ""}
                    onChange={e => onChange({ launcherIconUrl: e.target.value || null })}
                    helperText="Optional. Shown inside the launcher button."
                />

                <TextField
                    label="Welcome message"
                    fullWidth
                    multiline
                    minRows={3}
                    inputProps={{ maxLength: 500 }}
                    value={value.welcomeMessage ?? ""}
                    onChange={e => onChange({ welcomeMessage: e.target.value || null })}
                    helperText="First message shown when the chat opens."
                />
            </div>
            <div className="integration-step__preview">
                <LauncherPreview
                    displayName={value.launcherDisplayName ?? ""}
                    primaryColor={value.launcherPrimaryColor ?? "#1976d2"}
                    iconUrl={value.launcherIconUrl}
                    welcomeMessage={value.welcomeMessage}
                />
            </div>
        </div>
    );
}
